module.exports = __webpack_public_path__ + "static/img/java.b06019ef.png";